import { useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-300/40 bg-background-50/85 backdrop-blur-md">
      <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-8 md:py-4">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-primary-500/40 bg-primary-500/10 text-primary-300">
            <i className="ri-moon-fill text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg font-bold tracking-wide text-foreground-950">午夜影院</span>
            <span className="font-label mt-1 text-[10px] text-foreground-500">MIDNIGHT CINEMA</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.target}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <span className="hidden items-center gap-2 rounded-full border border-background-300/60 bg-background-100 px-3 py-1.5 text-xs text-foreground-500 md:inline-flex">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500 animate-slow-pulse" />
            深夜不打烊
          </span>
          <a
            href="#latest"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-play-list-2-line" />
            立即找片
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300/60 text-foreground-700 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-300/40 bg-background-50 px-4 pb-5 pt-4 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.target}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md px-3 py-2.5 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-900"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#latest"
            onClick={() => setOpen(false)}
            className="mt-3 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-play-list-2-line" />
            立即找片
          </a>
        </div>
      ) : null}
    </header>
  );
}